/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const MAIN_SIDEBAR_WIDTH = 12;
export const MAIN_TOPBAR_HEIGHT = 12;
